(function() {
  'use strict';

  angular
    .module('modals.editProfile', ['factories.utils', 'service.account'])
    .controller('EditProfileCtrl', EditProfileCtrl);

  EditProfileCtrl.$inject = ['$scope', '$timeout', 'textLengthIndicatorState', '$rootScope', 'mtypes', 'dashboardResource', 'errorHandler', 'Utils', 'gettextCatalog'];

  function EditProfileCtrl($scope, $timeout, textLengthIndicatorState, $rootScope, mtypes, dashboardResource, errorHandler, Utils, gettextCatalog) {
    var takenUsernames = [];
    var takenEmails = [];
    var incorrectPasswords = [];
    var repeatedPasswords = [];
    var formFieldValidityCache = {};
    var formAllTextLengthKeys = {
      firstName: 35,
      lastName: 35,
      email: 254,
      password: 35,
      username: 50
    };
    var storedUserInfo = {};

    // this does nothing emit goes up ...there is nothing up from rootScope
    $rootScope.$emit("initPlaceholders");

    var requiredKeys = ['firstName', 'lastName', 'email'];

    function recalcFormTextLengthIndicators() {
      for (var key in formAllTextLengthKeys) {
        _validateFormTextLength(key);
      }
      $scope.modal.valid = calcFormValidity();
    }

    $scope.onFormFieldInputBlur = function(key) {
      // leave errors
      var state = formFieldValidityCache[key];
      if (!state.lengthValid || !state.dataValid)
        return;

      applyFormState(key, textLengthIndicatorState.defaultState);
    };

    var emailRegex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

    function _validateFormTextLength(key) {
      var text = $scope.modal.data[key];
      var state = textLengthIndicatorState.getState(text, formAllTextLengthKeys[key]);

      if (~requiredKeys.indexOf(key) && (!text || !text.trim().length > 0)) {
        state.dataValid = false;
      } else if (key === 'email') {
        state.dataValid = state.lengthValid && emailRegex.test($scope.modal.data[key]);
      } else if (key === 'password') {
        if (!$scope.modal.data.currentPassword ||
          !$scope.modal.data.password2 ||
          $scope.userForm.password.$error.any || $scope.userForm.passwordConfirm.$error.compareTo) {
          state.dataValid = false;
          state.lengthValid = $scope.userForm.password.$error.passwordLen;
        } else {
          state.dataValid = true;
          state.lengthValid = !$scope.userForm.password.$error.passwordLen;
        }
      }

      applyFormState(key, state);
      formFieldValidityCache[key] = state;

      validateTaken(key, text);
    }

    $scope.validateFormTextLength = function(key) {
      _validateFormTextLength(key);
      $scope.modal.valid = calcFormValidity() && validateUserModel($scope.modal.data);
      $scope.modal.dirty = calcFormDirty();
    };

    $scope.onFormFieldFocus = function(key) {
      applyFormState(key, formFieldValidityCache[key]);
    };

    function validateTaken(key, text) {
      if (key === 'username') {
        if (text && ~takenUsernames.indexOf(text.toLowerCase())) {
          $scope.modal.usernameError = "(Username already in use)";
        } else {
          $scope.modal.usernameError = "";
        }
      } else if (key === 'email') {
        if (text && ~takenEmails.indexOf(text.toLowerCase())) {
          $scope.modal.emailError = "(Email already in use)";
        } else {
          $scope.modal.emailError = "";
        }
      } else if (key === 'currentPassword') {
        if (text && ~incorrectPasswords.indexOf(text.toLowerCase())) {
          $scope.modal.currentPasswordError = 'current password is incorrect';
          $scope.currentPasswordStyle = 'redBorder';
        }
      } else if (key === 'repeatedPassword') {
        if(text && ~repeatedPasswords.indexOf(text.toLowerCase())) {
          $scope.modal.repeatedPasswordError = 'Your password cannot be a recently used password';
        }
      }

    }

    function applyFormState(key, state) {
      $scope[key + 'IndicatorStyle'] = state.style;
      $scope[key + 'IndicatorText'] = state.text;
      if (key !== 'password')
        $scope[key + 'Style'] = state.dataValid ? '' : 'redBorder';
    }

    function validateUserModel(model) {
      // first and last are required
      if (!model.firstName || !model.lastName)
        return false;
      if (!(model.email || model.username))
        return false;

      return true;
    }

    function calcFormValidity() {
      if (!validateUserModel($scope.modal.data))
        return false;

      for (var key in formFieldValidityCache) {
        if (key === 'username') {
          formFieldValidityCache[key] = getUsernameState();
        }
        if (key === 'email') {
          formFieldValidityCache[key] = getEmailState();
        }
        if (key === 'password') {
          formFieldValidityCache[key] = getPasswordState();
        }
        if (!formFieldValidityCache[key].lengthValid || !formFieldValidityCache[key].dataValid) {
          return false;
        }
      }

      return true;
    }

    function calcFormDirty() {
      if (($scope.userForm.oldPassword.$dirty ||
          $scope.userForm.password.$dirty ||
          $scope.userForm.passwordConfirm.$dirty)) {
        return true;
      }

      for (var key in formFieldValidityCache) {
        var text = $scope.modal.data[key] ? $scope.modal.data[key].trim() : null;
        if (text !== storedUserInfo[key]) {
          return true;
        }
      }
      return false;
    }

    function getUsernameState() {
      var key = 'username';
      var usernameText = $scope.modal.data[key];
      // initial load
      if (usernameText === undefined)
        return { lengthValid: true, dataValid: true };

      var state = textLengthIndicatorState.getState(usernameText, formAllTextLengthKeys[key]);

      if (valueMissing(key))
        return state;

      if (!valueMissing(key) && usernameText.length > 0)
        return state;

      return { lengthValid: true, dataValid: true };
    }

    function getEmailState() {
      var key = 'email';
      var emailText = $scope.modal.data[key];
      // initial load
      if (emailText === undefined)
        return { lengthValid: true, dataValid: true };

      // trainee with a username
      if (!valueMissing('username'))
        return { lengthValid: true, dataValid: true };

      var state = textLengthIndicatorState.getState(emailText, formAllTextLengthKeys[key]);


      // email is required when a trainee lacks a username
      if (valueMissing('username') && valueMissing('email'))
        return state;

      // test valid email regex
      if (!emailRegex.test(emailText)) {
        state.dataValid = false;
        return state;
      }

      return { lengthValid: true, dataValid: true };
    }

    function getPasswordState() {
      if (!$scope.modal.data.currentPassword && !$scope.userForm.password.$viewValue && !$scope.userForm.passwordConfirm.$viewValue) {
        return { lengthValid: true, dataValid: true };
      }

      if (!$scope.modal.data.currentPassword) {
        return { lengthValid: false, dataValid: false };
      }

      return {
        lengthValid: !$scope.userForm.password.$error.passwordLen,
        dataValid: $scope.userForm.password.$viewValue &&
        $scope.userForm.passwordConfirm.$viewValue &&
        !$scope.userForm.password.$error.any &&
        !$scope.userForm.passwordConfirm.$error.compareTo
      };
    }

    function valueMissing(key) {
      return !$scope.modal.data[key] || $scope.modal.data[key].trim().length === 0;
    }

    $scope.form = {
      valid: true,
      dirty: false
    };

    $scope.modal = {
      content: 0,
      data: {
        userId: '',
        firstName: '',
        lastName: '',
        email: '',
        currentPassword: '',
        password: '',
        password2: '',
        username: ''
      },
      status: '',
      showUsername: false,
      usernameError: '',
      emailError: ''
    };

    $scope.modal.status = 'loading';

    dashboardResource.getAccountInfo(function(res) {
      storedUserInfo = res;
      $scope.modal.status = '';
      $scope.modal.data = {
        userId: res.userId,
        firstName: res.firstName,
        lastName: res.lastName,
        email: res.email,
        currentPassword: '',
        password: '',
        username: res.username
      };
      $scope.modal.showUsername = res.accountInfo.loginMode === mtypes.loginMode.username;
      recalcFormTextLengthIndicators();
    }, function() {
      $scope.$dismiss();
      $timeout(errorHandler.showGenericServerError);
    });

    $scope.saveUser = function() {
      if ($scope.userForm.password.$viewValue && $scope.userForm.password.$invalid) {
        return;
      }

      $scope.modal.status = 'saving';

      var info = {};

      if (fieldChanged('firstName'))
        info.firstName = $scope.modal.data.firstName;
      if (fieldChanged('lastName'))
        info.lastName = $scope.modal.data.lastName;
      if (fieldChanged('email'))
        info.email = $scope.modal.data.email;
      if ($scope.modal.data.password)
        info.password = $scope.modal.data.password;
      if ($scope.modal.data.currentPassword)
        info.currentPassword = $scope.modal.data.currentPassword;
      if (fieldChanged('username'))
        info.username = $scope.modal.data.username || null;

      info.selectedLanguage = gettextCatalog.currentLanguage;

      dashboardResource.updateUserInfo(
        $scope.modal.data.userId,
        info,
        function(res) {
          $scope.$dismiss();
          // TODO: update $rootScope vars if needed (like traineename, email, etc)
        },
        function(err) {
          if (err && err.data === "The username entered is already in use.") {
            takenUsernames.push(info.username.toLowerCase());
            validateTaken('username', info.username);
          } else if (err && err.data === "The email address entered is already in use.") {
            takenEmails.push(info.email.toLowerCase());
            validateTaken('email', info.email);
          } else if (err && err.data === "The current password is incorrect") {
            incorrectPasswords.push(info.currentPassword.toLowerCase());
            validateTaken('currentPassword', info.currentPassword);
          } else if (err && err.data === "The current password is repeated in history") {
            repeatedPasswords.push(info.password.toLowerCase());
            validateTaken('repeatedPassword', info.password);
          } else {
            $scope.$dismiss();
            $timeout(errorHandler.showGenericServerError);
          }
          $scope.modal.status = '';
          return true;
        }
      );
    };

    function fieldChanged(arg) {
      return $scope.modal.data[arg] !== storedUserInfo[arg];
    }

    $scope.goToPrivacyPolicy = function() {
      Utils.viewUrlInBrowser('https://www.mindflash.com/privacy-policy/');
    };
  }
})();
